import React, { useState, useEffect, useCallback } from 'react';
import AiSuggestionPanel from './AiSuggestionPanel';
import api from '../../lib/api';

/**
 * ReportingAssistant – appears on Reports pages.
 * Generates financial insights based on report data.
 *
 * Props:
 *  - reportData: object with financial summary (revenue, expenses, trends, etc.)
 *  - reportType: string – "pl" | "balance_sheet" | "dashboard"
 */
export default function ReportingAssistant({ reportData = null, reportType = '' }) {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasRequested, setHasRequested] = useState(false);

  const fetchInsights = useCallback(async () => {
    if (!reportData || hasRequested) return;
    setHasRequested(true);
    setLoading(true);

    try {
      const res = await api.post('/ai/suggestions', {
        context_type: 'reporting',
        payload: {
          report_type: reportType,
          ...reportData,
        },
      });
      setSuggestions(res.data || []);
    } catch {
      setSuggestions([]);
    }
    setLoading(false);
  }, [reportData, reportType, hasRequested]);

  useEffect(() => {
    if (reportData && !hasRequested) {
      const t = setTimeout(fetchInsights, 1000);
      return () => clearTimeout(t);
    }
  }, [reportData, fetchInsights, hasRequested]);

  return (
    <AiSuggestionPanel
      title="AI Insight"
      suggestions={suggestions}
      loading={loading}
      onAccept={() => {}}
      onDismiss={() => setSuggestions([])}
      className="mb-4"
    />
  );
}
